(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beezgone-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var cartForm = document.getElementById('cart');
    if (!cartForm) return;

    var qtyButtons = cartForm.querySelectorAll('.qty-btn');

    qtyButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var change = parseInt(btn.getAttribute('data-qty-change'), 10) || 0;
        var qtyInput = btn.parentElement.querySelector('input[type="number"]');

        if (!qtyInput) return;

        var current = parseInt(qtyInput.value, 10);
        if (isNaN(current)) current = 0;

        var next = current + change;
        if (next < 0) next = 0;

        qtyInput.value = next;

        // Make sure the hidden "update" input exists
        var updateInput = cartForm.querySelector('input[name="update"]');
        if (!updateInput) {
          updateInput = document.createElement('input');
          updateInput.type = 'hidden';
          updateInput.name = 'update';
          updateInput.value = 'Update cart';
          cartForm.appendChild(updateInput);
        }

        // Submit the form to update cart
        cartForm.submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beezgone-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var navs = document.querySelectorAll('[data-header-nav]');

    if (!navs.length) return;

    navs.forEach(function(nav) {
      var toggle = nav.querySelector('[data-nav-toggle]');
      var menu   = nav.querySelector('[data-header-menu]'); // .nav-menu
      var right  = nav.querySelector('.nav-right');         // account + cart

      if (!toggle) return;

      toggle.addEventListener('click', function () {
        // marks nav as open (for any generic styling)
        nav.classList.toggle('nav-open');

        // show/hide the menu links if present
        if (menu) {
          menu.classList.toggle('is-open');
          menu.classList.toggle('nav-menu-open'); // for your existing rule
        }

        // show/hide the right-side icons on mobile
        if (right) {
          right.classList.toggle('is-open');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
